<template>
  <div class="overview">
    <el-row v-if="displayData.val2 === 'elevator'">
      <div style="height: 40px;"></div>
    </el-row>
    <!--更换空间-->
    <el-row v-if="displayData.val1 === 'space' && displayData.val2 !== 'map' && displayData.val2 !== 'elevator'">
      <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8">
        <img src="../../../assets/images/index/roomIcon.png" alt=""
             style="margin-left: 1.3vw;margin-top: 10px;float: left;margin-right: 5px;">
        <div style="line-height: 40px;">
          <span style="color: rgba(7, 230, 248, 1)">{{ currentSpaceInfo.title }}</span>
          <a class="pointer text-white" style="margin-left: 10px;"
          @touchstart="clickSpaceTree"   @click="spaceTreeDisable = !spaceTreeDisable">更换空间</a>
        </div>
        <space-choose @close="spaceTreeDisable = false"
                      @spaceClick="spaceClick"
                      :currentSpaceInfo="currentSpaceInfo"
                      ref="spaceChoose" v-show="spaceTreeDisable"></space-choose>
      </el-col>
      <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8">
        <div style="line-height: 40px;text-align: center">
          <span style="font-weight: bolder;font-size: 16px;">设备地图</span>
        </div>
      </el-col>
      <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="text-align: right">
        <div style="line-height: 40px;vertical-align: center;margin-right: 1.3vw" @touchstart="closeMapToDcimApp" @click="closeMapToDcimApp">
          <img src="../../../assets/images/dcim_app_h5/mapBack.png" alt="">
          <a class="pointer text-white" style="margin-left: 5px;">退出地图</a>
        </div>
      </el-col>
    </el-row>

    <div v-if="displayData.val1 === 'space'">
      <!--内景图展示-->
      <indoor-setting-view v-on:childByValue="childByValue" :currentSpaceInfo="currentSpaceInfo" :tagCode="tagCode"
                           v-if="displayData.val2 === 'indoor' || displayData.val2 === 'elevator'"></indoor-setting-view>
    </div>

  </div>
</template>

<script>
import SpaceChoose from "@/views/overview/SpaceChoose";
import IndoorSettingView from "@/views/dcim_vue_app/device_map/IndoorSettingView";
import {getCustomPage, savePage} from "@/network/device-custom-page";
import {getSystematicByCodes} from "@/network/systematic";
import {getSpaceInfoById} from "@/network/space-info";
import _ from 'lodash'

export default {
  name: "Overview",
  components: {
    IndoorSettingView,
    SpaceChoose
  },
  data() {
    return {
      page: 'configurationList',
      currentSpaceInfo: {id: '0', title: '暂无空间'},
      dialogVisible: false,
      spaceTreeDisable: false,
      displaySystem: {},
      displayData: {},
      viewMode: '',
      selectMode: '',
      operation: '',
      deviceCustomPage: {},
      deviceCustomLayouts: [],
      code: "overview_display_mode",
      selectList: [{
        id: 1,
        name: '内景图',
        label: 'indoor',
      }, {
        id: 2,
        name: '组态列表',
        label: 'list',
      }],
      tagCode: '',
      // 清除实时告警弹窗定时器
      clearAlarmTimer: null
    };
  },
  mounted() {
    this.clearAlarmDialog();
    this.getByCodes();
    if (this.$route.query.spaceId !== '' && this.$route.query.spaceId !== null) {
      this.currentSpaceInfo.id = this.$route.query.spaceId
    }
    if (this.$route.query.spaceName !== '' && this.$route.query.spaceName !== null) {
      this.currentSpaceInfo.title = this.$route.query.spaceName
    }
    this.$cookies.set("currentSpaceInfo", JSON.stringify(this.currentSpaceInfo))
  },
  destroyed() {
    // 清除告警弹窗信息定时器
    clearInterval(this.clearAlarmTimer)
    this.clearAlarmTimer = null
  },
  methods: {
    // 退出地图
    closeMapToDcimApp() {
      this.$confirm('确定要退出地图地图吗？', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            // eslint-disable-next-line no-undef
            uni.navigateBack({
              delta: 1
            });
          }
        }
      })
    },
    // 清除实时告警弹窗
    clearAlarmDialog() {
      this.clearAlarmTimer = setInterval(() => {
        if (document.getElementsByClassName('el-notification right').length !== 0) {
          for( let i = 0; i < document.getElementsByClassName('el-notification right').length; i++ ) {
            // 清除实时告警弹窗
            document.getElementsByClassName('el-notification right')[i].style.display = 'none'
          }
          // 清除告警弹窗信息定时器
          clearInterval(this.clearAlarmTimer)
          this.clearAlarmTimer = null
        }
      }, 500)
    },
    //更换按钮
    spaceClick(data, init) {
      // 大屏跳转过来
      if (this.$route.query.spaceId) {
        this.currentSpaceInfo = {id: this.$route.query.spaceId, title: this.$route.query.spaceName}
        this.$cookies.set("currentSpaceInfo", JSON.stringify(this.currentSpaceInfo))
      } else {
        const currentSpaceInfo = this.$cookies.get("currentSpaceInfo")
        if (currentSpaceInfo && init) {
          getSpaceInfoById(currentSpaceInfo.id).then(res => {
            if (res.data) {
              this.currentSpaceInfo = currentSpaceInfo
            } else {
              this.currentSpaceInfo = data
              this.$cookies.set("currentSpaceInfo", JSON.stringify(data))
            }
          })
          //节点选中
          this.$refs.spaceChoose.selectNode(this.currentSpaceInfo);
        } else {
          this.currentSpaceInfo = data;
          //防止子节点太大，情况子节点
          this.currentSpaceInfo.children = [];
          this.$cookies.set("currentSpaceInfo", JSON.stringify(data))
        }
        this.spaceTreeDisable = false;
        this.getCustomPageInfo();
      }

    },
    childByValue: function (childByValue) {
      // childValue就是子组件传过来的值
      if (childByValue === '停车') {
        this.displayData.val2 = 'elevator'
      } else {
        this.displayData.val1 = 'space'
        this.displayData.val2 = 'indoor'
      }
    },
    //获取展示方式配置
    getByCodes() {
      getSystematicByCodes(this.code).then(res => {
        if (res.code === 0) {
          this.displaySystem = res.data[0]
          if (this.$route.query.spaceId) {
            this.tagCode = this.$route.query.tagCode
            this.displayData = {
              val1: 'space',
              val2: 'indoor',
            }
          } else {
            this.displayData = _.cloneDeep(this.displaySystem)
          }
        }
      })
    },
    changeMode(val1, val2) {
      this.displayData.val1 = val1
      this.displayData.val2 = val2
    },
    getDisplayMode(val) {
      this.selectMode = val;
    },
    //获取自定义页面信息
    //获取组态列表自定义页面(没有则保存)
    getCustomPageInfo() {
      getCustomPage(this.page).then(res => {
        if (res.code === 0) {
          if (res.data === null) {
            let deviceCustomPageDto = {
              deviceCustomPage: {page: this.page, name: '组态列表'},
              deviceCustomLayouts: [{
                name: 'common',
                component: 'indoor',
                params: JSON.stringify({position: {left: 20, top: 0, width: 350, height: 290}}),
              }, {
                name: 'common',
                component: 'deviceTotal',
                params: JSON.stringify({position: {left: 20, top: 310, width: 350, height: 115}}),
              }]
            };
            savePage(deviceCustomPageDto).then(() => {
              this.getCustomPageInfo();
            })
          } else {
            this.deviceCustomPage = res.data.deviceCustomPage;
            if (res.data.deviceCustomLayouts.length > 0) {
              this.deviceCustomLayouts = res.data.deviceCustomLayouts
                .filter(item => item.name === this.currentSpaceInfo.id || item.name === 'common')
                .map(item => {
                  item.paramsData = JSON.parse(item.params);
                  return item;
                })
            }
          }
        }
      })
    },
    mapToIndoor(val) {
      this.displayData.val2 = val
    }
  }
}
</script>

<style scoped>
</style>
